import { render, staticRenderFns } from "./GeneralInput.vue?vue&type=template&id=b17dd204&scoped=true&"
import script from "./GeneralInput.vue?vue&type=script&lang=js&"
export * from "./GeneralInput.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInput.vue?vue&type=style&index=0&id=b17dd204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17dd204",
  null
  
)

export default component.exports